import { render, staticRenderFns } from "./PaymentResFlutterWave.vue?vue&type=template&id=5aba8663&scoped=true&"
import script from "./PaymentResFlutterWave.vue?vue&type=script&lang=js&"
export * from "./PaymentResFlutterWave.vue?vue&type=script&lang=js&"
import style0 from "./PaymentResFlutterWave.vue?vue&type=style&index=0&id=5aba8663&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aba8663",
  null
  
)

export default component.exports